export default __webpack_public_path__ + "static/anya-topolskiimage-122d7915b9c05fca4a1f902d1bb7b79c.png";